import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAlphaNumeric]'
})
export class AlphaNumericDirective {

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow 0-9, A-Z, a-z
    if (
      !(charCode >= 48 && charCode <= 57) && // numbers
      !(charCode >= 65 && charCode <= 90) && // uppercase letters
      !(charCode >= 97 && charCode <= 122) // lowercase letters
    ) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();

    const pastedInput = event.clipboardData?.getData('text') || '';
    const sanitized = pastedInput.replace(/[^a-zA-Z0-9]/g, ''); // remove non-alphanumeric
    const currentValue = this.el.nativeElement.value;

    // Insert sanitized text at cursor position
    const start = this.el.nativeElement.selectionStart || 0;
    const end = this.el.nativeElement.selectionEnd || 0;
    this.el.nativeElement.value = currentValue.substring(0, start) + sanitized + currentValue.substring(end);

    // move cursor to end of inserted text
    const cursorPos = start + sanitized.length;
    this.el.nativeElement.setSelectionRange(cursorPos, cursorPos);

    // Setting .value programmatically doesn't emit an input event, so Angular's
    // form binding would never see the pasted text without this.
    this.el.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
